export const hideEmptyImageCredits = (root = document) => {
    const credits = root.querySelectorAll(".image-credit");

    credits.forEach((credit) => {
        if (credit.textContent.trim() === "") {
            credit.classList.add("hidden");
        }
    });
};
